import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasAnalyticsConsent, loadGtm, pushPageView } from 'utils/analytics';

declare global {
  interface Window {
    dataLayer: any[]
  }
}

const usePageViews = () => {
  const location = useLocation();

  useEffect(
    () => {
      if (!hasAnalyticsConsent()) return;

      loadGtm();
      pushPageView(location.pathname + location.search);
    },
    [location]
  );
};

export { usePageViews };
